import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import AuthContext from "./AuthContext";

const PrivateRoute = ({ element: Component }) => {
  const { authTokens } = useContext(AuthContext);

  // If not logged in, go to login
  if (!authTokens) return <Navigate to="/login" replace />;

  // Logged in, render the page component
  return <Component />;
};

export default PrivateRoute;
